import { render, staticRenderFns } from "./LunchManager.vue?vue&type=template&id=9f663eb4&"
import script from "./LunchManager.vue?vue&type=script&lang=js&"
export * from "./LunchManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports